import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
// Import breadcrumb types to enable route meta type checking
import '@/types/breadcrumbs'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        // the children array here, can be extracted and used in all other integrations.
        {
            path: '/',
            component: () => import('@/components/HomeView.vue'),
            children: [
                {
                    path: '',
                    name: 'Home',
                    component: () => import('../pages/home.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', current: true }
                        ]
                    }
                },
                {
                    path: 'dvir',
                    name: 'DVIR',
                    component: () => import('../components/dvir/Dvirs.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'DVIR', current: true }
                        ]
                    }
                },
                {
                    path: 'settings',
                    name: 'Settings',
                    component: () => import('../pages/settings.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Settings', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/users',
                    name: 'Users',
                    component: () => import('../pages/admin/users.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Users', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/roles',
                    name: 'Roles',
                    component: () => import('../pages/admin/roles.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Roles', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/clients',
                    name: 'Clients',
                    component: () => import('../pages/admin/clients.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Clients', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/missing-lookups',
                    name: 'MissingLookups',
                    component: () => import('../pages/admin/missing-lookups.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Missing Lookups', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/groups',
                    name: 'Groups',
                    component: () => import('../components/groups/Group.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Groups', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/audits',
                    name: 'Audits',
                    component: () => import('../pages/admin/audits.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Audits', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/user_tags',
                    name: 'User Tags',
                    component: () => import('../pages/admin/user_tags.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'User Tags', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/system_tags',
                    name: 'System Tags',
                    component: () => import('../pages/SystemTags.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'System Tags', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/workflows',
                    name: 'Workflows',
                    component: () => import('../pages/admin/workflows/index.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Workflows', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/configuration',
                    name: 'Configuration',
                    component: () => import('../pages/admin/configuration.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Configuration', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/coverage-dashboard',
                    name: 'CoverageDashboard',
                    component: () => import('../pages/admin/coverage-dashboard.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'Coverage Dashboard', current: true }
                        ]
                    }
                },
                {
                    path: 'notification_users',
                    name: 'NotificationUsers',
                    component: () => import('../pages/notification_users.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Notification Users', current: true }
                        ]
                    }
                },
                // Routes now handled via slide-out panel in NotificationUsers page
                // {
                //     path: 'notification_users/new',
                //     name: 'AddNotificationUser',
                //     component: () => import('../pages/add_notification_user.vue')
                // },
                // {
                //     path: 'notification_users/:id/edit',
                //     name: 'EditNotificationUser',
                //     component: () => import('../pages/edit_notification_user.vue')
                // },
                {
                    path: 'signatures',
                    name: 'Signatures',
                    component: () => import('../pages/signatures.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Signatures', current: true }
                        ]
                    }
                },
                {
                    path: 'signatures/new',
                    name: 'AddSignature',
                    component: () => import('../pages/add_signature.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Signatures', to: '/signatures' },
                            { name: 'New Signature', current: true }
                        ]
                    }
                },
                {
                    path: 'signatures/:id/edit',
                    name: 'EditSignature',
                    component: () => import('../pages/edit_signature.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Signatures', to: '/signatures' },
                            { name: 'Edit Signature', current: true }
                        ]
                    }
                },
                {
                    path: 'services/service_tasks',
                    name: 'Service Tasks',
                    component: () => import('../pages/service_tasks.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Service Tasks', current: true }
                        ]
                    }
                },
                {
                    path: 'services/service_programs',
                    name: 'Service Programs',
                    component: () => import('../pages/service_programs.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Service Programs', current: true }
                        ]
                    }
                },
                {
                    path: 'services/service_reminders',
                    name: 'Service Reminders',
                    component: () => import('../pages/service_reminders.vue'),
                    path: 'services/renewal_reminders',
                    name: 'Renewal Reminders',
                    component: () => import('../pages/renewal_reminders.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Renewal Reminders', current: true }
                        ]
                    }
                },
                {
                    path: 'services/work_orders',
                    name: 'Work Orders',
                    component: () => import('../pages/work_orders.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Work Orders', current: true }
                        ]
                    }
                },
                {
                    path: 'services/fuel_energy',
                    name: 'Fuel & Energy',
                    component: () => import('../pages/fuel_energy.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Fuel & Energy', current: true }
                        ]
                    }
                },
                {
                    path: 'services/work_order_calendar',
                    name: 'Work Order Calendar',
                    component: () => import('../pages/work_order_calendar.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Work Order Calendar', current: true }
                        ]
                    }
                },
                {
                    path: 'services/pending_authorizations',
                    name: 'Pending Authorizations',
                    component: () => import('../pages/pending_authorizations.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Pending Authorizations', current: true }
                        ]
                    }
                },
                {
                    path: 'approvals',
                    name: 'Workflow Approvals',
                    component: () => import('../pages/approvals/PendingApprovalsPage.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Approvals', current: true }
                        ]
                    }
                },
                {
                    path: 'services/issues',
                    name: 'Issues',
                    component: () => import('../pages/issues.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Issues', current: true }
                        ]
                    }
                },
                {
                    path: 'parts',
                    name: 'Parts',
                    component: () => import('../pages/parts.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Parts', current: true }
                        ]
                    }
                },
                {
                    path: 'services/tires',
                    name: 'Tire Management',
                    component: () => import('../pages/tires.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Services' },
                            { name: 'Tire Management', current: true }
                        ]
                    }
                },
                {
                    path: 'vendors',
                    name: 'Vendors',
                    component: () => import('../pages/vendors.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Vendors', current: true }
                        ]
                    }
                },
                {
                    path: 'warranty_claims',
                    name: 'Warranty Claims',
                    component: () => import('../pages/WarrantyClaims.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Warranty Claims', current: true }
                        ]
                    }
                },
                {
                    path: 'warranties',
                    name: 'Warranties',
                    component: () => import('../pages/WarrantyManagementPage.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Warranties', current: true }
                        ]
                    }
                },
                {
                    path: 'vendor_bill_backs',
                    name: 'Vendor Bill Backs',
                    component: () => import('../pages/VendorBillBacks.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Vendor Bill Backs', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/dashboard',
                    name: 'Predictive Dashboard',
                    component: () => import('../components/dashboard/CustomizableDashboard.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Dashboard', current: true }
                        ]
                    }
                },
                // Training & LMS Routes
                {
                    path: 'training/enrollments',
                    name: 'My Enrollments',
                    component: () => import('../pages/training/enrollments.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Training' },
                            { name: 'My Enrollments', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/map',
                    name: 'Map',
                    component: () => import('../pages/map.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Map', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/timeline',
                    name: 'TimeLine',
                    component: () => import('../pages/timeline.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Timeline', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/timeline/:id',
                    name: 'TimeLineId',
                    component: () => import('../pages/timeline.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Timeline', to: '/predictive/timeline' },
                            { name: 'Vehicle Timeline', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/reporting',
                    name: 'Reporting',
                    component: () => import('@/pages/reporting.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Reporting', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/reports',
                    name: 'Reports Library',
                    component: () =>
                        import('@/pages/predictive/reports.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Reports', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/reports/:slug',
                    name: 'Report Viewer',
                    component: () =>
                        import(
                            '@/pages/predictive/report-viewer.vue'
                        ),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            {
                                name: 'Reports',
                                to: '/predictive/reports'
                            },
                            { name: 'Report', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/digital-twin/calendar',
                    name: 'Maintenance Calendar',
                    component: () =>
                        import('../pages/predictive/maintenance-calendar.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            {
                                name: 'Digital Twin',
                                to: '/predictive/digital-twin'
                            },
                            { name: 'Maintenance Calendar', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/replacement-analysis',
                    name: 'Replacement Analysis',
                    component: () =>
                        import(
                            '../pages/predictive/replacement-analysis.vue'
                        ),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Replacement Analysis', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/digital-twin',
                    name: 'Digital Twin Overview',
                    component: () =>
                        import('../pages/predictive/digital-twin.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            { name: 'Digital Twin', current: true }
                        ]
                    }
                },
                {
                    path: 'predictive/digital-twin/:id',
                    name: 'Vehicle Digital Twin',
                    component: () =>
                        import(
                            '../pages/predictive/digital-twin-vehicle.vue'
                        ),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Predictive' },
                            {
                                name: 'Digital Twin',
                                to: '/predictive/digital-twin'
                            },
                            { name: 'Vehicle', current: true }
                        ]
                    }
                },
                {
                    path: 'training/courses',
                    name: 'My Courses',
                    component: () => import('../pages/training/courses.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Training' },
                            { name: 'My Courses', current: true }
                        ]
                    }
                },
                {
                    path: 'training/courses/:id',
                    name: 'Course Details',
                    component: () => import('../pages/training/course.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Training' },
                            { name: 'My Courses', to: '/training/courses' },
                            { name: 'Course Details', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses',
                    name: 'Manage Courses',
                    component: () => import('../pages/admin/lms/courses.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Courses', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/new',
                    name: 'Add Course',
                    component: () => import('../pages/admin/lms/courses/new.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Courses', to: '/admin/lms/courses' },
                            { name: 'New Course', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/topics',
                    name: 'Manage Topics',
                    component: () => import('../pages/admin/lms/topics.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Topics', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/topics/new',
                    name: 'Add Topic',
                    component: () => import('../pages/admin/lms/topics/new.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Topics', to: '/admin/lms/topics' },
                            { name: 'New Topic', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/tracks',
                    name: 'Manage Tracks',
                    component: () => import('../pages/admin/lms/tracks.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Tracks', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/tracks/new',
                    name: 'Add Track',
                    component: () => import('../pages/admin/lms/tracks/new.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Tracks', to: '/admin/lms/tracks' },
                            { name: 'New Track', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/instructors',
                    name: 'Manage Instructors',
                    component: () => import('../pages/admin/lms/instructors.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Instructors', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/instructors/new',
                    name: 'Add Instructor',
                    component: () => import('../pages/admin/lms/instructors/new.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Instructors', to: '/admin/lms/instructors' },
                            { name: 'New Instructor', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/enrollments',
                    name: 'Course Enrollments',
                    component: () => import('../pages/admin/lms/enrollments.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Enrollments', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/lessons',
                    name: 'admin-lms-courses-lessons',
                    component: () => import('@/pages/admin/lms/courses/lessons.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Lessons', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/lessons/new',
                    name: 'admin-lms-courses-lessons-new',
                    component: () => import('@/pages/admin/lms/courses/lessons/new.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Lessons', to: '/admin/lms/courses/lessons' },
                            { name: 'New Lesson', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/lessons/:id/edit',
                    name: 'admin-lms-courses-lessons-edit',
                    component: () => import('@/pages/admin/lms/courses/lessons/edit.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Lessons', to: '/admin/lms/courses/lessons' },
                            { name: 'Edit Lesson', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/lessons/:id/content',
                    name: 'admin-lms-courses-lessons-content',
                    component: () => import('@/pages/admin/lms/courses/lessons/content.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Lessons', to: '/admin/lms/courses/lessons' },
                            { name: 'Lesson Content', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/courses/lessons/:id',
                    name: 'admin-lms-courses-lessons-show',
                    component: () => import('@/pages/admin/lms/courses/lessons/show.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Lessons', to: '/admin/lms/courses/lessons' },
                            { name: 'Lesson Details', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/training-sessions',
                    name: 'admin-lms-training-sessions',
                    component: () => import('@/pages/admin/lms/training_sessions.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Training Sessions', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/training-sessions/:id',
                    name: 'admin-lms-training-sessions-detail',
                    component: () => import('@/pages/admin/lms/session_detail.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Training Sessions', to: '/admin/lms/training-sessions' },
                            { name: 'Session Details', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/compliance',
                    name: 'admin-lms-compliance',
                    component: () => import('@/pages/admin/lms/compliance_dashboard.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Compliance', current: true }
                        ]
                    }
                },
                {
                    path: 'admin/lms/share_analytics',
                    name: 'admin-lms-share-analytics',
                    component: () => import('@/pages/admin/lms/share_analytics.vue'),
                    meta: {
                        requiresAuth: true,
                        adminRequired: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Admin' },
                            { name: 'LMS' },
                            { name: 'Share Analytics', current: true }
                        ]
                    }
                },
                {
                    path: 'incident_manager',
                    name: 'Incident Manager',
                    component: () => import('@/pages/IncidentManager.vue'),
                    meta: {
                        hideSidebar: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Incident Manager', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory',
                    name: 'Inventory',
                    component: () => import('@/components/inventory/InventoryDashboard.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory/alerts',
                    name: 'Stock Alerts',
                    component: () => import('@/pages/inventory/alerts.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', to: '/inventory' },
                            { name: 'Stock Alerts', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory/locations',
                    name: 'Inventory Locations',
                    component: () => import('@/pages/inventory/locations.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', to: '/inventory' },
                            { name: 'Locations', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory/transfers',
                    name: 'Inventory Transfers',
                    component: () => import('@/pages/inventory/transfers.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', to: '/inventory' },
                            { name: 'Transfers', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory/adjustments',
                    name: 'Inventory Adjustments',
                    component: () => import('@/pages/inventory/adjustments.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', to: '/inventory' },
                            { name: 'Adjustments', current: true }
                        ]
                    }
                },
                {
                    path: 'inventory/parts/:partId/movements',
                    name: 'Part Movements',
                    component: () => import('@/pages/inventory/part-movements.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Inventory', to: '/inventory' },
                            { name: 'Part Movements', current: true }
                        ]
                    }
                },
                {
                    path: 'procurement',
                    name: 'Procurement',
                    component: () => import('@/components/procurement/ProcurementDashboard.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Procurement', current: true }
                        ]
                    }
                },
                {
                    path: 'procurement/purchase_orders',
                    name: 'Purchase Orders',
                    component: () => import('@/pages/procurement/purchase_orders.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Procurement', to: '/procurement' },
                            { name: 'Purchase Orders', current: true }
                        ]
                    }
                },
                {
                    path: 'procurement/procurement_records',
                    name: 'Procurement Records',
                    component: () => import('@/pages/procurement/procurement_records.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Procurement', to: '/procurement' },
                            { name: 'Records', current: true }
                        ]
                    }
                },
                {
                    path: 'procurement/invoices',
                    name: 'Invoices',
                    component: () => import('@/pages/procurement/invoices.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Procurement', to: '/procurement' },
                            { name: 'Invoices', current: true }
                        ]
                    }
                },
                {
                    path: 'procurement/payments',
                    name: 'Vendor Payments',
                    component: () => import('@/pages/procurement/payments.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Procurement', to: '/procurement' },
                            { name: 'Vendor Payments', current: true }
                        ]
                    }
                },
                {
                    path: 'assets',
                    name: 'Assets',
                    component: () => import('@/pages/equipment.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Assets', current: true }
                        ]
                    }
                },
                {
                    path: 'assets/:id',
                    name: 'Vehicle Detail',
                    component: () => import('@/pages/vehicle-detail.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Assets', to: '/assets' },
                            { name: 'Vehicle Detail', current: true }
                        ]
                    }
                },
                {
                    path: 'assets/categories',
                    name: 'Asset Categories',
                    component: () => import('@/pages/AssetCategories.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Assets', to: '/assets' },
                            { name: 'Categories', current: true }
                        ]
                    }
                },
                // ── Workbench (OFH Staff) ──────────────────────────
                {
                    path: 'workbench',
                    component: () => import('@/pages/workbench/WorkbenchLayout.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Workbench', current: true }
                        ]
                    },
                    children: [
                        {
                            path: '',
                            name: 'WorkbenchDashboard',
                            component: () => import('@/pages/workbench/DashboardView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', current: true }
                                ]
                            }
                        },
                        {
                            path: 'spn',
                            name: 'SpnExplorer',
                            component: () => import('@/pages/workbench/SpnExplorerView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'SPN Explorer', current: true }
                                ]
                            }
                        },
                        {
                            path: 'spn/:id',
                            name: 'CodeDetail',
                            component: () => import('@/pages/workbench/CodeDetailView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'SPN Explorer', to: '/workbench/spn' },
                                    { name: 'Code Detail', current: true }
                                ]
                            }
                        },
                        {
                            path: 'vehicles',
                            name: 'VehicleLookup',
                            component: () => import('@/pages/workbench/VehicleLookupView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'Vehicle Lookup', current: true }
                                ]
                            }
                        },
                        {
                            path: 'drafts/:id',
                            name: 'SignatureBuilder',
                            component: () => import('@/pages/workbench/SignatureBuilderView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'Signature Builder', current: true }
                                ]
                            }
                        },
                        {
                            path: 'preview/:id',
                            name: 'SignaturePreview',
                            component: () => import('@/pages/workbench/SignaturePreviewView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'Signature Preview', current: true }
                                ]
                            }
                        },
                        {
                            path: 'research',
                            name: 'ResearchQueue',
                            component: () => import('@/pages/workbench/ResearchQueueView.vue'),
                            meta: {
                                breadcrumbs: [
                                    { name: 'Home', to: '/' },
                                    { name: 'Workbench', to: '/workbench' },
                                    { name: 'Research Queue', current: true }
                                ]
                            }
                        }
                    ],
                },
                {
                    path: 'documents',
                    name: 'Documents',
                    component: () => import('@/pages/documents.vue'),
                    meta: {
                        breadcrumbs: [
                            { name: 'Home', to: '/' },
                            { name: 'Documents', current: true }
                        ]
                    }
                }
            ]
        },
        {
            path: '/im/:notification_user_id/:incident_id',
            name: 'IncidentManagerShortcut',
            redirect: (to) => ({
                path: '/incident_manager',
                query: {
                    notification_user_id: to.params.notification_user_id,
                    incident_id: to.params.incident_id
                }
            })
        },
        {
            path: '/shared/lesson/:token',
            name: 'SharedLesson',
            component: () => import('../pages/public/SharedLesson.vue'),
            meta: { requiresAuth: false }
        },
        // Embed routes — chrome-less layout for iframe embedding from v1 portal
        {
            path: '/embed/predictive/twin',
            name: 'EmbedAuth',
            component: () => import('@/pages/embed/EmbedAuth.vue'),
            meta: { requiresAuth: false }
        },
        {
            path: '/embed/view',
            component: () => import('@/pages/embed/EmbedLayout.vue'),
            children: [
                {
                    path: 'predictive/digital-twin',
                    name: 'EmbedDigitalTwin',
                    component: () =>
                        import('@/pages/predictive/digital-twin.vue'),
                    meta: { requiresAuth: false, isEmbed: true }
                },
                {
                    path: 'predictive/digital-twin/:id',
                    name: 'EmbedDigitalTwinVehicle',
                    component: () =>
                        import('@/pages/predictive/digital-twin-vehicle.vue'),
                    meta: { requiresAuth: false, isEmbed: true }
                },
                {
                    path: 'predictive/digital-twin/calendar',
                    name: 'EmbedMaintenanceCalendar',
                    component: () =>
                        import('@/pages/predictive/maintenance-calendar.vue'),
                    meta: { requiresAuth: false, isEmbed: true }
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('../pages/login.vue')
        },
        {
            path: '/login/sms',
            name: 'LoginSMS',
            component: () => import('../pages/login.vue')
        },
        {
            path: '/:geotab_database',
            component: () => import('@/pages/geotab.vue')
        },
        {
            path: '/:catchAll(.*)', // Catch-all route for 404
            name: 'NotFound',
            redirect: '/logins'
        }
    ]
})
router.beforeEach(async (to, from) => {
    const authStore = useAuthStore()

    // Skip auth check for public routes and embed routes
    if (to.meta.requiresAuth === false || to.name === 'SharedLesson' || to.path.startsWith('/embed')) {
        return
    }

    if (!window.location.href.includes('my.geotab.com') && !authStore.state.isLoggedIn) {
        // If already navigating to a login page, don't redirect
        if (to.name === 'Login' || to.name === 'LoginSMS') {
            // If no redirect parameter is present and we're coming from a non-login page, add the from path as redirect
            if (!to.query.redirect && from.path !== '/login' && from.path !== '/login/sms') {
                return {
                    name: to.name,
                    query: {
                        ...to.query,
                        redirect: from.fullPath
                    }
                }
            }
            return
        }

        // If trying to access incident manager, redirect to appropriate login method
        if (to.path.includes('/incident_manager')) {
            // If mobile_number is in query params, always use SMS login
            if (to.query.mobile_number) {
                return {
                    name: 'LoginSMS',
                    query: { redirect: to.fullPath }
                }
            }

            // Get saved login preferences
            const savedLoginPreferences = localStorage.getItem('loginPreferences')
            let loginName = 'Login' // Default to email login

            // Check saved preferences if they exist and Remember Me was checked
            if (savedLoginPreferences) {
                const preferences = JSON.parse(savedLoginPreferences)
                if (preferences.rememberMe && preferences.loginType === 'sms') {
                    loginName = 'LoginSMS'
                }
            }

            return {
                name: loginName,
                query: { redirect: to.fullPath }
            }
        }

        // For all other routes, redirect to appropriate login based on preferences
        const savedLoginPreferences = localStorage.getItem('loginPreferences')
        let loginName = 'Login' // Default to email login

        if (savedLoginPreferences) {
            const preferences = JSON.parse(savedLoginPreferences)
            if (preferences.rememberMe && preferences.loginType === 'sms') {
                loginName = 'LoginSMS'
            }
        }

        return {
            name: loginName,
            query: { redirect: to.fullPath }
        }
    }
})

export default router
